import type { SettingsColumnHead } from '@/modules/settings';

/** The Settings log's column titles, rendered in the page's sticky header. */
export const SETTINGS_LOG_COLUMNS: SettingsColumnHead[] = [
	{ id: 'at', header: 'Date & time', className: 'w-[160px]' },
	{ id: 'actor', header: 'Changed by', className: 'w-[200px]' },
	{ id: 'setting', header: 'Setting', className: 'w-[240px]' },
	{ id: 'change', header: 'Change' }
];
